import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Bolos/hooks/useBolo.ts
/**
* Get a single Bolo data
* @param args
* @param opts
*/
function useBolo(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Bolos.GetBolo.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args?.boloId
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useBolo };

//# sourceMappingURL=useBolo.js.map